import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import './index.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Process from './pages/Process';
import Work from './pages/Work';
import About from './pages/About';
import Contact from './pages/Contact';

// Scroll to top on every route change
function ScrollToTop() {
 const { pathname } = useLocation();
 useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
 return null;
}

function Layout() {
 return (
 <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
 <Navbar />
 <ScrollToTop />
 <main style={{ flex: 1 }}>
 <Routes>
 <Route path="/" element={<Home />} />
 <Route path="/services" element={<Services />} />
 <Route path="/process" element={<Process />} />
 {/* <Route path="/work" element={<Work />} />
 <Route path="/about" element={<About />} /> */}
 <Route path="/contact" element={<Contact />} />
 {/* Catch-all → home */}
 <Route path="*" element={<Home />} />
 </Routes>
 </main>
 <Footer />
 </div>
 );
}

export default function App() {
 return (
 <BrowserRouter>
 <Layout />
 </BrowserRouter>
 );
}
